import { Component } from 'react';
import { connect } from 'react-redux';
import Head from 'react-helmet';

import MobileAppsHero from 'app/shared/modules/mobile-apps/MobileAppsHero';
import FeaturesSection from 'app/shared/modules/mobile-apps/FeaturesSection';
import MoreInfoSection from 'app/shared/modules/mobile-apps/MoreInfoSection';

class MobileAppsPage extends Component {
  render() {
    return (
      <div className="MobileAppsPage">
        <Head
          meta={[
            {
              name: 'description',
              content: 'Download the HotPads mobile app for iOs and Android.',
            },
          ]}
          title="HotPads mobile apps for iOS and Android | HotPads"
        />
        <MobileAppsHero />
        <FeaturesSection />
        <MoreInfoSection />
      </div>
    );
  }
}

export default connect()(MobileAppsPage);
